/* eslint-disable ember/no-controller-access-in-routes */
import Route from '@ember/routing/route';

export default class StudentNoticesRoute extends Route {
  activate() {
    super.activate(...arguments);
    this.controllerFor('application').set('currentPageId', null);
    this.controllerFor('application').set('isViewingStudentNotices', true);
  }

  deactivate() {
    super.deactivate(...arguments);
    this.controllerFor('application').set('isViewingStudentNotices', false);
  }
}
